const baseUrl = process.env.NODE_ENV === 'development'
  ? 'https://local.gassien.com'
  : ''

const baseApiUrlMaker = process.env.NODE_ENV === 'development'
  ? 'http://localhost:3333/dev'
  : 'https://api.gassien.com/maker'

export const GET_COMPOSITION_URL = `${baseApiUrlMaker}/schema/`
export const POST_COMPOSITION_URL = `${baseApiUrlMaker}/schema/`


export const LOGO_URL = `${baseUrl}/wp-content/uploads/2017/01/logo.png`
export const GF_URL = `${baseUrl}/wp-content/uploads/external/base80.png`
export const MF_URL = `${baseUrl}/wp-content/uploads/external/base60.png`
export const PF_URL = `${baseUrl}/wp-content/uploads/external/base40.png`
export const GS_URL = `${baseUrl}/wp-content/uploads/external/base80x44.png`
export const MS_URL = `${baseUrl}/wp-content/uploads/external/base60x44.png`

export const BOARD_URL = `${baseUrl}/wp-content/uploads/external/board.png`

export const POT_HOLDER_URL = `${baseUrl}/wp-content/uploads/external/potholder.png`
export const TOWEL_RACK_40_URL = `${baseUrl}/wp-content/uploads/external/towelrack_40.png`
export const TOWEL_RACK_60_URL = `${baseUrl}/wp-content/uploads/external/towelrack_60.png`
export const VASE_HOLDER_10_URL = `${baseUrl}/wp-content/uploads/external/vaseholder_10.png`
export const VASE_HOLDER_15_URL = `${baseUrl}/wp-content/uploads/external/vaseholder_15.png`
export const FRAME_HOLDER_40_URL = `${baseUrl}/wp-content/uploads/external/frameholder_40.png`
export const WIRE_SUPPORT_URL = `${baseUrl}/wp-content/uploads/external/wireSupport_menu.png`
export const COMPUTER_HOLDER_URL = `${baseUrl}/wp-content/uploads/external/computerholder.png`
export const HANGER_HOLDER_URL = `${baseUrl}/wp-content/uploads/external/hangerHolder.png`
export const GLASSES_RACKS_WITH_GLASSES_URL = `${baseUrl}/wp-content/uploads/external/glassesHolders_withGlasses.png`
export const GLASSES_RACKS_URL = `${baseUrl}/wp-content/uploads/external/glassesHolders.png`
export const WARDROBE_40_MENU_URL = `${baseUrl}/wp-content/uploads/external/wardrobe40_pres.png`
export const WARDROBE_60_MENU_URL = `${baseUrl}/wp-content/uploads/external/wardrobe60_pres.png`
export const WARDROBE_80_MENU_URL = `${baseUrl}/wp-content/uploads/external/wardrobe80_pres.png`

export const HOOKS_URL = `${baseUrl}/wp-content/uploads/external/hooks.png`

export const ZENITH_PPOT_URL = `${baseUrl}/wp-content/uploads/external/bom/pres_lampe-zenith-portepot.png`
export const ZENITH_PVER_URL = `${baseUrl}/wp-content/uploads/external/bom/pres_lampe-zenith-broche.png`
export const HALO_PPOT_URL = `${baseUrl}/wp-content/uploads/external/bom/pres_lampe-halo-portepot.png`
export const HALO_PVER_URL = `${baseUrl}/wp-content/uploads/external/bom/pres_lampe-halo-broche.png`
export const LUMI_URL = `${baseUrl}/wp-content/uploads/external/bom/pres_vase-lumi.png`
export const FLUX_URL = `${baseUrl}/wp-content/uploads/external/bom/pres_vase-flux.png`
export const ECHO_URL = `${baseUrl}/wp-content/uploads/external/bom/pres_miroir-echo.png`
export const ONDE_URL = `${baseUrl}/wp-content/uploads/external/bom/pres_miroir-onde.png`
export const TABLES_GIGOGNES_URL = `${baseUrl}/wp-content/uploads/external/tables_gigognes.png`


export const BLACK_URL = `${baseUrl}/wp-content/uploads/external/swatches/color_black.png`
export const WHITE_URL = `${baseUrl}/wp-content/uploads/external/swatches/color_white.png`
export const BRASS_URL = `${baseUrl}/wp-content/uploads/external/swatches/color_brass.png`
export const OAK_URL = `${baseUrl}/wp-content/uploads/external/swatches/color_oak.png`
export const BIRCH_URL = `${baseUrl}/wp-content/uploads/external/swatches/color_birch.png`

export const COLOR_URLS = {
  black: BLACK_URL,
  white: WHITE_URL,
  brass: BRASS_URL,
  oak: OAK_URL,
  birch: BIRCH_URL,
}

export const PASTILLES_URL = {
  black: {
    black: `${baseUrl}/wp-content/uploads/external/pastilles/p_n_n.png`,
    white: `${baseUrl}/wp-content/uploads/external/pastilles/p_n_bc.png`,
    oak: `${baseUrl}/wp-content/uploads/external/pastilles/p_n_c.png`,
    birch: `${baseUrl}/wp-content/uploads/external/pastilles/p_n_b.png`,
  },
  white: {
    black: `${baseUrl}/wp-content/uploads/external/pastilles/p_bc_n.png`,
    white: `${baseUrl}/wp-content/uploads/external/pastilles/p_bc_bc.png`,
    oak: `${baseUrl}/wp-content/uploads/external/pastilles/p_bc_c.png`,
    birch: `${baseUrl}/wp-content/uploads/external/pastilles/p_bc_b.png`,
  },
  brass: {
    black: `${baseUrl}/wp-content/uploads/external/pastilles/p_l_n.png`,
    white: `${baseUrl}/wp-content/uploads/external/pastilles/p_l_bc.png`,
    oak: `${baseUrl}/wp-content/uploads/external/pastilles/p_l_c.png`,
    birch: `${baseUrl}/wp-content/uploads/external/pastilles/p_l_b.png`,
  },
}

export const STEP_WALL_BASES_URL = `${baseUrl}/wp-content/uploads/external/steps/7_wall_bases.png`
export const STEP_BOARDS_URL = `${baseUrl}/wp-content/uploads/external/steps/step_boards.png`
export const STEP_BOARD_URL = `${baseUrl}/wp-content/uploads/external/steps/planches.png`
export const STEP_BOARDS_DIMENSIONS_URL = `${baseUrl}/wp-content/uploads/external/steps/dimensions planches.png`

export const ACCESSORIES_URL = {
  fr: `${baseUrl}/wp-content/uploads/external/steps/accessoires-FR.png`,
  en: `${baseUrl}/wp-content/uploads/external/steps/accessoires-EN.png`,
  de: `${baseUrl}/wp-content/uploads/external/steps/accessoires-DE.png`,
}
